import React from "react";
import PanelShell from "../../shared/PanelShell";
import { fmtNumber, labelFor } from "../../shared/format";
import { ROW_HOVER } from "./rowStyles";
import CrossChannelNote from "./crossChannelNote";

// summary.attribution ranked list — how people say they found the property.
// Render verbatim. `label` differs per channel: the chat spec writes its heading
// "In visitors own words", missing apostrophe and all, so the label is a prop
// rather than a string this component owns.
const AttributionPanel = ({ panelKey, label, say, summary, loading, crossChannel = false, onSelect }) => {
  const items = Array.isArray(summary?.attribution) ? summary.attribution :
    (summary?.attribution?.items ? summary.attribution.items : []);
  return (
    <PanelShell panelKey={panelKey} label={label} say={say} hasData={items.length > 0} loading={loading}>
      <ul className="space-y-2">
        {items.map((it, i) => {
          // Stored values are snake_case ("previous_chat_interaction"); render the
          // labelled form, never the raw database vocabulary.
          const text = (
            <>
              {labelFor(it.label || it.source || it.channel)} {it.count != null && <span className="text-gray-500 dark:text-gray-400">({fmtNumber(it.count)})</span>}
            </>
          );
          // Each row drills fn_drill('source', …) when the payload carries a drill.
          const drillable = !!onSelect && !!it.drill;
          if (!drillable) {
            return (
              <li key={i} className={`gi-body text-gray-700 dark:text-gray-300 py-1 ${ROW_HOVER}`}>{text}</li>
            );
          }
          return (
            <li key={i}>
              <button
                type="button"
                data-source={it.drill?.id || it.source}
                onClick={() => onSelect(it)}
                className={`w-full text-left gi-body text-gray-700 dark:text-gray-300 py-1 min-h-[44px] rounded-md px-1 -mx-1 ${ROW_HOVER} focus:outline-none focus-visible:ring-2 focus-visible:ring-[#32B1FF]`}
              >
                {text}
              </button>
            </li>
          );
        })}
      </ul>
      <CrossChannelNote when={crossChannel} />
    </PanelShell>
  );
};

export default AttributionPanel;
